import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

// Shared "How the AIS-140 Ticketing Tool Works" trigger + modal, dropped
// into the ticketing pages (My AIS 140 Tickets, Ticket Details,
// Institutional Sales) so the explanation only has to be maintained in one
// place. Written for the customer support/operations team, not developers -
// see the panel's own content for the full walkthrough (ticket sources,
// validation, the four stages, device state/VIN linking and auto FOTA,
// change requests, certificate renewal,
// completion rules, TAT tracking, external sync, and permissions).
@Component({
  selector: 'app-ticketing-info',
  standalone: true,
  imports: [MatIcon, MatTooltip],
  templateUrl: './ticketing-info.component.html',
  styleUrl: './ticketing-info.component.scss',
})
export class TicketingInfoComponent {
  isOpen = false;

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  // See fota-info.component.ts for why window.print() (not a PDF library).
  exportPdf(): void {
    window.print();
  }
}
